// extracted by mini-css-extract-plugin
export var externalLink = "_bq-0";
export var internalLinkLabel = "_bq-1";